<template>
  <white-bg padding="25px 30px">
    <preload-content :loading="!masters" min-height="300px">
      <template v-if="masters">
        <h3>Статистика мастеров</h3>
        <div class="clients" :key="date" v-for="(item, date) in list">
          <div class="date">{{ date }}</div>
          <div class="item" v-for="master in item.masters" :key="master.id">
            <div class="wrap">
              <img :src="master.avatar" alt="">
              <div class="items">
                <div class="name">
                  {{ master.name }}
                </div>
                <div class="phone">
                  {{ master.phone }}
                </div>
              </div>
              <!--todo CHAT-->
              <button @click="createConversation(master.id)">Чат</button>
            </div>
          </div>
        </div>
        <button v-if="page !== last_page" @click="more()">Показать еще</button>
        <h3 v-if="list && !Object.keys(list).length" style="text-align: center">Список пуст</h3>
      </template>
    </preload-content>
  </white-bg>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg'
import PreloadContent from '@/components/ui/preload-content';
import ChatMixin from "@/mixins/chat";
import moment from "moment";

export default {
  name: "master",
  components: {WhiteBg, PreloadContent},
  mounted() {
    this.loadMasters();
  },
  mixins: [ChatMixin],
  data() {
    return {
      page: 1,
      last_page: 1,
      masters: null,
    }
  },
  computed: {
    list() {
      if (!this.masters) return null;
      let itm = {};
      this.masters.forEach((val) => {
        let date = moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').format('D MMMM, dddd');
        if (!itm[date]) itm[date] = {masters: []};
        itm[date].masters.push(val);
      });
      return itm;
    },
  },
  methods: {
    more() {
      this.page = this.page + 1;
      this.loadMasters(true);
    },
    loadMasters(more) {
      this.$api.admin.analytic.master.list({page: this.page}).then((data) => {
        this.page = data.meta.current_page;
        this.last_page = data.meta.last_page;
        more ? data.data.forEach((val) => this.masters.push(val)) : this.masters = data.data;
      });
    },
  },
}
</script>

<style scoped lang="scss">
h3 {
  margin-bottom: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
}

h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

button {
  width: 100%;
  height: 50px;
  background: initial;
  border: 2px solid #DBBFA7;
  box-sizing: border-box;
  border-radius: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 20px;
}

.date {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.7;
  color: #808080;
  border-bottom: 1px solid #E5E5E5;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 30px;
  padding-bottom: 6px;
}

.clients {
  margin: 0 -30px;
  padding: 0 20px;
  //border-bottom: 1px solid #E5E5E5;

  .item {
    border-bottom: 1px solid #E5E5E5;
    margin: 0 -20px;
    padding: 0 30px;
    .wrap {
      display: flex;
      align-items: center;
      margin: 15px 0;
      width: 100%;

      .name {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #383838;
      }

      .phone {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #808080;
      }
    }

    .date {
      margin: -1px -30px 0 -30px;
      border-bottom: 1px solid #E5E5E5;
      padding: 0 30px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: #808080;
      margin-top: 20px;
    }

    button {
      margin-top: 0;
      margin-left: auto;
      width: 70px;
      height: 50px;
    }

    img {
      border-radius: 50%;
      border: 1px solid #DBBFA7;
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
}

@media screen and (max-width: 991px) {
  .whiteBg {
    overflow: hidden;
    padding: 15px !important;
  }
}
</style>
